import {useEffect, useState} from 'react';

interface ISizes {
  screenWidth: number;
  screenHeight: number;
}

const useWindowDimensions = (): ISizes => {
  const [screenWidth, setWidth] = useState(window.innerWidth);
  const [screenHeight, setHeight] = useState(window.innerHeight);

  const onResize = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };

  useEffect(() => {
    window.addEventListener('resize', onResize);

    return () => window.removeEventListener('resize', onResize);
  }, []);

  return {screenWidth, screenHeight};
};

export default useWindowDimensions;

//
const useScreenScroll = (): number => {
  const [screenScroll, setScreenScroll] = useState(window.scrollY);

  const onScroll = () => {
    setScreenScroll(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return screenScroll;
};

export {useScreenScroll};
